import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'ca09bbe1-5ef2-4b0e-99c0-6c6e57b5413c',
  ENV: 'citopiaPo',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: true,
  },
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
